module.exports = __webpack_public_path__ + "static/media/subtitle_pin.1115fd8d.svg";